import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL, getToken } from '../asyncConfig';

export const getAllRefunds = createAsyncThunk(
  'rides/getAllRefunds', async (criteria, {rejectWithValue, fulfillWithValue}) => {
    try {
      const {data} = await axios.get(
        `${BASE_URL}/admin/retrieve/refunds/${criteria}`,
        {headers: {Authorization: `Bearer ${getToken()}`}}
      );
      return fulfillWithValue(data.refunds);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const getRefundFulfilled = (state, action) => {
  console.log('action', action);
  state.status = '';
  state.refunds = action.payload;
}